import React from 'react';

function Faq() {
  return (
    <>
      <h2>faq</h2>
    </>
  );
}

export default Faq;